module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/lindt/ortho-field-config-translation.json
// module id = 1387
// module chunks = 0